import { makeStyles } from 'tss-react/mui';

export const AccessibilityLabelStyles = makeStyles()(() => ({
  accessibilityLabel: {
    width: 'fit-content',
    margin: '0.4rem 0',
    lineHeight: 'normal',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '& > span': {
      fontSize: '12px',
      textDecoration: 'underline',
      paddingLeft: '0.2rem',
    },
  },
}));
